import React, { useRef, useState, useEffect } from "react";

import { Grid } from "@mui/material";

import EmailEditor from "react-email-editor";

const Editor = ({ template, onChange }) => {
  const emailEditorRef = useRef(null);

  const [isReady, setReady] = useState(false);

  const onLoad = () => {
    if (!isReady) return;
    if (emailEditorRef.current && emailEditorRef.current.editor && template) {
      if (template.json)
        emailEditorRef.current.editor.loadDesign(template.json);
    }
    emailEditorRef.current.editor.addEventListener(
      "design:updated",
      function (data) {
        emailEditorRef.current.editor.exportHtml((data) => {
          const { design, html } = data;
          if (onChange) onChange(design, html);
        });
        console.log("design updated", template);
      }
    );
  };

  useEffect(() => {
    onLoad();
  }, [template, emailEditorRef.current, isReady]);

  // useEffect(() => {
  //   if (isReady && emailEditorRef?.current) {
  //   }
  // }, [emailEditorRef, isReady]);

  const onReady = () => {
    // editor is ready
    console.log("onReady");
    if (!isReady) setReady(true);
  };

  return (
    <Grid item container sx={{ overflow: "hidden" }}>
      <EmailEditor
        ref={emailEditorRef}
        // onLoad={onLoad}
        // onChange={onChange}
        onReady={onReady}
        minHeight="80vh"
      />
    </Grid>
  );
};

export default Editor;
